<template>
  <div>
    <report-base
      title="Transactions"
      table-class="analytics-tables--transactions"
      subject="transaction"
      :items="transactions"
      :fields="fields"
      :is-loading="loading"
      @reload="loadData"
    />
  </div>
</template>

<script>
import AnalyticsMixin from "./mixin";

export default {
  name: "Transactions",

  mixins: [AnalyticsMixin],

  data() {
    return {
      transactions: [],
      filter: "",
      fields: [
        {
          key: "booking_name",
          label: "Booking Name",
          sortable: true,
        },
        {
          key: "booking_id",
          label: "Booking Number",
          sortable: true,
        },
        {
          key: "check_in_at",
          label: "Check-in Date",
          sortable: true,
        },
        {
          key: "check_out_at",
          label: "Check-out Date",
          sortable: true,
        },
        {
          key: "night_count",
          label: "No. Nights",
          sortable: true,
        },
        {
          key: "paid_amount",
          label: "Payment Amount",
          sortable: true,
        },
        {
          key: "paid_description",
          label: "Payment Description",
          sortable: true,
        },
        {
          key: "paid_date",
          label: "Date of Payment",
          sortable: true,
        },
        {
          key: "pitaya_transaction",
          label: "Pitaya Transaction",
          sortable: true,
        },
        {
          key: "stripe_transaction",
          label: "Stripe Transaction",
          sortable: true,
        },
        {
          key: "user_name",
          label: "User Name",
          sortable: true,
        },
      ],
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;

      this.fetchData("transaction")
        .then((res) => {
          this.transactions = res.data.map((item) => {
            item.check_in_at =
              item.check_in_at !== "NA"
                ? this.formatDate(item.check_in_at)
                : item.check_in_at;
            item.check_out_at =
              item.check_out_at !== "NA"
                ? this.formatDate(item.check_out_at)
                : item.check_out_at;
            item.paid_date = this.formatDate(item.paid_date);
            item.paid_amount = this.formatMoney(item.paid_amount);

            return item;
          });
        })
        .catch(() => {
          this.errorNotification("Feching transactions error!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.analytics-tables--transactions {
  table {
    min-width: 1800px !important;
  }
}
</style>
